<template>
  <div class="recommendation-program-comissions">
    <div class="row mb-5" v-if="comissions.length">
      <div class="col-lg-6 mb-5 mb-lg-0">
        <div class="d-flex align-items-start">
          <div class="d-flex flex-column">
            <div>
              <span class="text-primary fs-12">
                Qtd: {{ pagination.count || 0 }}
              </span>
              <button class="btn p-0 text-primary ml-3" @click="refresh">
                <i class="fa-solid fa-refresh" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="d-flex justify-content-end">
          <search-button
            @search="searching"
            placeholder="Pesquisar nome do produto ou indicado"
          />

          <button-export
            class="ml-3"
            :loading="exportLoading"
            :disabled="exportLoading || loading || !comissions.length"
            @input="exportData"
          />
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!comissions.length"
      class="container centralize-row text-center pt-5"
    >
      <img class="d-block mb-5 mx-auto" src="@/assets/images/no-content.svg" />

      <h4>Ainda não há nada aqui</h4>
      <span class="text-center text-primary-500 fs-14">
        Você não recebeu comissões dentro deste programa.
      </span>
      <br />
      <span class="text-primary-500 fs-14"
        >Para começar, copie o link acima</span
      >
    </div>

    <template v-else>
      <data-table
        class="d-none d-lg-block"
        :columns="columns"
        :data="comissions"
        columnsFr=".5fr 1fr 1fr .5fr .5fr .5fr .7fr"
        new-design
      >
        <template #default="{item}">
          <span>
            {{ item.id }}
          </span>
          <span class="crop">
            <div>
              {{ item.product_name }}
            </div>
          </span>
          <span class="crop">
            <div>
              {{ item.refer_company }}
            </div>
          </span>
          <span>{{ item.tax }}%</span>
          <span> R${{ formatMoney(item.amount_reward) }} </span>
          <span>{{ toHumanDate(item.make_payment_at) }}</span>
          <span>
            <span :class="formatStatusBadge(item.status)">
              {{ formatStatusName(item.status) }}
            </span>
          </span>
        </template>
      </data-table>

      <data-table
        new-design
        class="d-lg-none"
        :data="comissions"
        :columns="['', '']"
        :firstColumnFr="2"
        :lastColumnFr="0"
      >
        <template #default="{item}">
          <div class="responsive-table">
            <span>
              <strong>ID: </strong>
              {{ item.id }}
            </span>
            <span>
              <strong>Produto: </strong>
              {{ item.product_name }}
            </span>
            <span>
              <strong>Empresa: </strong>
              {{ item.refer_company }}
            </span>
            <span>
              <strong>Taxa: </strong>
              {{ item.tax }}%
            </span>
            <span>
              <strong>Comissão: </strong>
              R${{ formatMoney(item.amount_reward) }}
            </span>
            <span>
              <strong>Libera em: </strong>
              {{ toHumanDate(item.make_payment_at) }}
            </span>
            <span>
              <strong>Status: </strong>
              <span :class="formatStatusBadge(item.status)">
                {{ formatStatusName(item.status) }}
              </span>
            </span>
          </div>
        </template>
      </data-table>
    </template>

    <div class="d-flex justify-content-center justify-content-lg-end">
      <paginator
        v-show="pagination.count && !loading"
        ref="paginator"
        :pagination="pagination"
        @on-update="dispatch"
      />
    </div>
  </div>
</template>

<script>
import { formatMoney, toHumanDate } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

export default {
  data() {
    return {
      pagination: {},
      columns: [
        "ID",
        "Produto",
        "Empresa",
        "Taxa",
        "Comissão",
        "Libera em",
        "Status"
      ],
      loading: false,
      exportLoading: false,
      search: ""
    };
  },
  computed: {
    ...mapState("rewards", ["comissions"])
  },
  methods: {
    formatMoney,
    toHumanDate,
    formatStatusName(status) {
      const statusNames = {
        pending: "Aguardando Liberação",
        processed: "Processado",
        revert: "Estorno"
      };
      return statusNames[status];
    },
    formatStatusBadge(status) {
      const statusBadges = {
        pending: "draft-badge",
        processed: "active-badge",
        revert: "inactive-badge"
      };
      return statusBadges[status];
    },

    searching(v) {
      this.search = v;
      this.refresh();
    },
    refresh() {
      this.$refs.paginator.reset();
    },
    dispatch(offset = 0) {
      this.loading = true;
      this.$store
        .dispatch("rewards/getComissions", {
          search: this.search,
          offset
        })
        .then(({ next, previous, count }) => {
          this.pagination = { next, previous, count };
        })
        .finally(() => (this.loading = false));
    },
    async exportData(export_format) {
      try {
        this.exportLoading = true;

        const { data } = await this.$store.dispatch(
          "rewards/exportComissions",
          {
            search: this.search,
            export_format
          }
        );

        let href;
        if (export_format === "excel") {
          href = URL.createObjectURL(data);
        } else {
          href = `data:text/csv;charset=utf-8,${data.replaceAll("#", "%23")}`;
        }

        var a = document.createElement("a");
        a.href = href;
        a.setAttribute(
          "download",
          `refer_comissions_${moment().format("YYYYMMDD")}_${moment().unix()}.${
            export_format === "excel" ? "xlsx" : "csv"
          }`
        );
        a.click();
      } catch (e) {
        this.$message.error("Erro ao exportar dados");
      } finally {
        this.exportLoading = false;
      }
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
